import { createSelector } from 'reselect';
import { unmaskPhoneNumber } from '../../components/Onboarding/Unmasker';
import { contactsListSchema, ENTITY_CONTACTS, ENTITY_CONTACTS_LIST } from '../../Schema/ContactSchema.js';
import { EmptyObject, EmptyArray } from '../EmptyDefaults.js';
import { denormalize } from 'normalizr';
import ReferralApi from './ReferralApi.js';
import { getEntities } from '../EntityData';
import { isPresent } from 'utils/isPresent';

export const REFERRAL_UTMS_RECOMMENDED_CONTACTS = {
  source: 'product',
  campaign: 'viral-internal-referral-contractor',
  mc: 'product',
  msc: 'internal-referral-contractor',
};
export const REFERRAL_UTMS_GOOGLE = {
  source: 'google',
  campaign: 'viral-internal-referral',
  mc: 'product',
  msc: 'internal-referral',
};
export const REFERRAL_UTMS_EMAIL = {
  source: 'product',
  campaign: 'viral-internal-referral',
  mc: 'product',
  msc: 'internal-referral',
};

export const REFER_A_FRIEND = 'Refer a friend';

export const formatEmails = (emailsString) => {
  return emailsString
    .split(',')
    .filter((email) => isPresent(email))
    .map((email) => ({ email: email.trim() }));
};

export const formatGoogleContacts = (googleContacts) => {
  return googleContacts.map((contact) => {
    const formattedContact = {
      first_name: contact.first_name,
      last_name: contact.last_name,
      email: contact.email,
      ...(contact.mobile_number && { phones: [{ number: unmaskPhoneNumber(contact.mobile_number) }] }),
    };
    return formattedContact;
  });
};

export const formatExternalUserDetails = (pro) => ({
  first_name: pro.first_name,
  last_name: pro.last_name,
  external_uuid: pro.id,
  organization_name: pro.organization_name,
  email: pro.email,
});

const getHistoryState = (history) => history.location.state || EmptyObject;

export const getMessage = (history) => getHistoryState(history).message || '';

const getDenormalizedContacts = createSelector(getEntities, (entities) => {
  if (isPresent(entities) && isPresent(entities[ENTITY_CONTACTS_LIST])) {
    return denormalize('list', contactsListSchema, entities)[ENTITY_CONTACTS];
  }
  return EmptyArray;
});

export const getContactsList = createSelector(getEntities, (entities) => {
  if (isPresent(entities) && isPresent(entities[ENTITY_CONTACTS_LIST])) {
    return entities[ENTITY_CONTACTS_LIST].list;
  }
  return {};
});

export const fetchContacts = (externalUserDetails) => ({
  fetchingApiFunc: ReferralApi.recommended_contacts,
  selector: getDenormalizedContacts,
  paramsFromProps: () => [externalUserDetails],
  schema: contactsListSchema,
  alwaysFetch: false,
});

export const appendUtmContent = (object, utmContent) => {
  const appendParams = (object) => ({ ...object, content: utmContent });
  return isPresent(utmContent) ? appendParams(object) : object;
};
